import {  useState,useEffect,useRef   } from 'react'; // useEffect,

import { useNavigate } from 'react-router-dom';
import axios from 'axios.js';

import {

  Button,
  Box,
IconButton,
  Badge,
  Menu,
  MenuItem,
  Typography,Chip,Divider,Stack
} from '@mui/material';

// project import

// assets
import { BellOutlined } from '@ant-design/icons';


// ==============================|| HEADER CONTENT - NOTIFICATION ||============================== //

// Same task-status -> chip color mapping used in TaskFilters.jsx, so a
// task shows the same color here in the notification bell as it does in
// the task list itself.
const TASK_STATUS_COLORS = {
    Completed: 'success',
    'In Progress': 'warning',
    'Not Started': 'info',
    'On Hold': 'error',
};

const Notification = () => {

    const UserID = localStorage.getItem('id');
    const AdminUserID=localStorage.getItem("AdminUserID");
    const IsAdmin = (UserID===AdminUserID) ? true : false;
    const navigate = useNavigate();
    //let navigate = useNavigate();

    // Upgrade button
    const [IsButtonVisible,setIsButtonVisible] = useState(true)
    // FIX: JSON.parse(null) returns null, and PlanDetails.PlanName below
    // would then throw - guard with a fallback empty object so a missing
    // "Plans" key in localStorage doesn't crash the header on load.
    const [PlanDetails] = useState(() => {
        try {
            return JSON.parse(localStorage.getItem("Plans")) || {};
        } catch (e) {
            return {};
        }
    })

    const [anchorEl, setAnchorEl] = useState(null);
    const [notifications, setNotifications] = useState([]);
    const intervalRef = useRef(null);

    useEffect(()=>{

        if(PlanDetails.PlanName==="Free" || PlanDetails.IsActivePlan===0 || PlanDetails.IsCurentPlanToRenew==1)
        {
            setIsButtonVisible(true)
        }
        else if(PlanDetails.IsCurentPlanToRenew===0)
        {
            setIsButtonVisible(false)
        }
    },[PlanDetails]);

        // Both background-poll functions below are wrapped in try/catch now.
        // Previously, a failed request here (e.g. an expired session after
        // the tab sat idle) became an unhandled promise rejection - since
        // these run inside setInterval, unawaited, that surfaces as the
        // "Uncaught runtime errors" overlay rather than being caught
        // anywhere. Failing quietly here is correct: this is a silent
        // background refresh, not a user-initiated action, so it shouldn't
        // interrupt them with an error UI either way.
        const fetchCurrentPlan = async () => {
            try {
                const response = await axios.get('/load-user-plan',{
                params: {
                    tenant: localStorage.getItem('tenant'),
                    AdminUserID: AdminUserID,
                    UserID: UserID,
                }});

                if(response.data.Status===1)
                {
                    localStorage.setItem("Plans",JSON.stringify(response.data.Plan))
                }
            }
            catch (error)
            {
                console.warn('fetchCurrentPlan (background poll) failed:', error.message);
                if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                    handleSessionExpired();
                }
            }
        };

        const fetchReminders = async () => {
            try {
                const response = await axios.get('/fetch-reminders',{
                params: {
                    tenant: localStorage.getItem('tenant'),
                    AdminUserID: AdminUserID,
                    UserID: UserID,
                }});
                setNotifications(response.data.Tasks || []);
            }
            catch (error)
            {
                console.warn('fetchReminders (background poll) failed:', error.message);
                if (error.response && (error.response.status === 401 || error.response.status === 419)) {
                    handleSessionExpired();
                }
            }
        };

        // Session/token has genuinely expired (401/419) - retrying every
        // minute forever is pointless and will just keep failing. Stop the
        // interval and send them back to log in instead.
        const handleSessionExpired = () => {
            if (intervalRef.current) {
                clearInterval(intervalRef.current);
                intervalRef.current = null;
            }
            navigate('/login');
        };

        useEffect(() => {
            // Only actually poll while the tab is visible - browsers still
            // fire setInterval in background tabs, so without this a tab
            // left open (but not focused) for hours keeps hammering the
            // server the whole time. Also do an immediate refresh the
            // moment the tab becomes visible again, rather than waiting up
            // to 60s for the next tick - this is the "long standby" case
            // from before, handled at the source instead of just papering
            // over the resulting error.
            const poll = () => {
                if (document.visibilityState === 'visible') {
                    fetchReminders();
                    fetchCurrentPlan();
                }
            };

            intervalRef.current = setInterval(poll, 60000); // every 1 minute

            const handleVisibilityChange = () => {
                if (document.visibilityState === 'visible') {
                    poll();
                }
            };
            document.addEventListener('visibilitychange', handleVisibilityChange);

            return () => {
                if (intervalRef.current) clearInterval(intervalRef.current);
                document.removeEventListener('visibilitychange', handleVisibilityChange);
            };
        }, []);



        const UpgradePlan = () => {
            navigate("/upgrade-plan", { state: { IsUpdate: 1 } });
        };

        const RenewPlan = () => {
            navigate("/upgrade-plan", { state: { IsUpdate: 0 } });
        };

        const handleOpen = (event) => {
            setAnchorEl(event.currentTarget);
        };

        const handleClose = () => {
            setAnchorEl(null);
        };

  return (
    <>
       <Box sx={{ flexShrink: 0, ml: 0.75, }}>
        <Stack direction="row" spacing={1.5} alignItems="center">

            <Button variant="outlined" color="primary" onClick={UpgradePlan} disabled={!IsAdmin}>
                Upgrade
            </Button>

            {IsButtonVisible === true && (
                <Button variant="outlined" color="warning" onClick={RenewPlan} disabled={!IsAdmin}>
                    Renew
                </Button>
            )}

            <IconButton color="inherit" onClick={handleOpen}>
                <Badge badgeContent={notifications.length} color="error">
                    <BellOutlined color="default" />
                </Badge>
            </IconButton>

            <Menu
                anchorEl={anchorEl}
                open={Boolean(anchorEl)}
                onClose={handleClose}
                anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                PaperProps={{
                    sx: {
                        width: { xs: '90vw', sm: 380 },
                        maxWidth: 420,
                        mt: 1,
                    }
                }}
                MenuListProps={{ sx: { py: 0 } }}
            >
                {/* Pinned header - stays visible while the list below scrolls */}
                <Box
                    sx={{
                        px: 2,
                        py: 1.5,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                        borderBottom: '1px solid',
                        borderColor: 'divider',
                    }}
                >
                    <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>
                        Notifications
                    </Typography>
                    {notifications.length > 0 && (
                        <Chip size="small" variant="outlined" color="primary" label={notifications.length} />
                    )}
                </Box>

                {/* Scrollable list - capped height so a long list scrolls
                    inside the menu instead of growing past the viewport */}
                <Box sx={{ maxHeight: 360, overflowY: 'auto' }}>
                    {notifications.length > 0 ? (
                        notifications.map((notification, index) => (
                            <Box key={notification.TaskID ?? notification.id ?? index}>
                                <MenuItem
                                    sx={{
                                        alignItems: "flex-start",
                                        py: 1.5,
                                        px: 2,
                                        whiteSpace: "normal",
                                    }}
                                >
                                    <Box width="100%">
                                        <Box
                                            display="flex"
                                            justifyContent="space-between"
                                            alignItems="center"
                                            gap={1}
                                            mb={0.5}
                                        >
                                            <Typography variant="subtitle2" fontWeight={600}>
                                                {notification.TaskTitle}
                                            </Typography>

                                            <Chip
                                                label={notification.TaskStatus}
                                                size="small"
                                                color={TASK_STATUS_COLORS[notification.TaskStatus] || 'default'}
                                            />
                                        </Box>

                                        <Typography
                                            variant="body2"
                                            color="text.secondary"
                                            sx={{ mb: 1 }}
                                        >
                                            {notification.Description}
                                        </Typography>

                                        <Typography variant="caption" color="text.secondary">
                                            Due:{" "}
                                            {new Date(notification.DueDate).toLocaleString()}
                                        </Typography>
                                    </Box>
                                </MenuItem>

                                {index < notifications.length - 1 && <Divider />}
                            </Box>
                        ))
                    ) : (
                        <MenuItem disabled sx={{ justifyContent: 'center', py: 4 }}>
                            <Typography variant="body2" color="text.secondary">
                                No notifications
                            </Typography>
                        </MenuItem>
                    )}
                </Box>
            </Menu>

        </Stack>
    </Box>
    </>

  );
};

export default Notification;
